
export default function StringToTitleCase(textString) {
    if (typeof textString === 'string') {
        return textString.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }
    return textString;
}
